"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetAccountGeneral = class FieldsetAccountGeneral extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    accountTypes;
    async $$load_accountTypes() {
        return this.$fn.getEnumValuesFromSchema('AccountTypes');
    }
    roundingTypes;
    ux;
    b_4615685607825208_parameters;
    dataMembers = ['currencies', 'accountTypes', 'roundingTypes', 'ux', 'b_4615685607825208_parameters'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                currencies: null,
                accountTypes: null,
                roundingTypes: [{
                        value: null,
                        text: this.$fn.pgettext("RoundingType", "no rounding"),
                    },
                    {
                        value: 1,
                        text: this.$fn.pgettext("RoundingType", "round to 1"),
                    },
                    {
                        value: 5,
                        text: this.$fn.pgettext("RoundingType", "round to 5"),
                    },
                    {
                        value: 10,
                        text: this.$fn.pgettext("RoundingType", "round to 10"),
                    },
                ],
                ux: null,
                b_4615685607825208_parameters: {
                    role: "own",
                },
            },
        };
    }
    get isReadOnly() {
        if (this.loaded) {
            return this.item.locked;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_6618 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_6617 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_6618,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_6617],
        });
        return {
            act_7315092382398562_reloadComponentData_6618,
            evh_7315092382398562_reload_6617,
            evh_7315092382398562_reload,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetAccountGeneral.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetAccountGeneral.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetAccountGeneral.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetAccountGeneral.prototype, "onLabel_align", null);
FieldsetAccountGeneral = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetAccountGeneral);
exports.default = FieldsetAccountGeneral;
vue_property_decorator_1.Vue.component("FieldsetAccountGeneral", FieldsetAccountGeneral);
